<template>
<el-tree class="tree-w-stroke obj-tree" ref="chartTree" :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false" @node-click="onClickNode" :filter-node-method="filterNode" :allow-drop="allowDrop">
  <span class="el-tree-node__label" slot-scope="{ node, data }">
    <!-- obj -->
    <drag v-if="isObjNode(data)" :transfer-data="node" @dragstart="onDragObj" @dragend="onDragEnd" style="display: inline; line-height:19px; padding-left: 3px;">
      <!-- <span>{{ node.label }}</span> -->
      <el-tooltip v-if="isObjNode(data) && isRequireIPObjType(data)" class="item" effect="dark" :content="getIpTooltipContent(data)" placement="right">
        <span>
          <span v-if="hasObjTypeIcon(data)" class="obj-icon">
            <i :class="getObjTypeIconClass(data)"></i>
          </span>
        <span>{{data.label}}</span>
      </span>
      </el-tooltip>
      <span v-else-if="isObjNode(data)">
        <span v-if="!isEmpty(data.subType)" class="obj-icon">
          <i :class="getObjTypeIconClass(data)"></i>
        </span>
        <span>{{data.label}}</span>
      </span>
    </drag>
    <!-- root, group -->
    <span v-else class="group">{{ node.label }}</span>
  </span>
</el-tree>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import TreeFilter from '@/mixins/tree/filter';
import { defaultProps, rootNode } from '@/constants/tree';
import { isRequireIPObjType, getObjTypeIconClass, isObjNode, getIpTooltipContent, hasObjTypeIcon } from '@/utils/tree';
import { getValueAfterCheckEmpty } from '@/utils/string';
import TreeAPI from '@/api/common/tree';
import DragTreeMixin from './mixins/drag-tree';

export default {
  name: 'WLogicalTree',
  mixins: [TreeFilter, DragTreeMixin],
  data() {
    return {
      treeRef: 'chartTree',
      treeData: null,
      defaultProps,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    isEmpty,
    isObjNode,
    isRequireIPObjType,
    hasObjTypeIcon,
    getObjTypeIconClass,
    getIpTooltipContent,
    getValueAfterCheckEmpty,
    loadData() {
      TreeAPI.getLogicalTreeData({ exceptDefineIds: ['SERVICE'] }).then((response) => {
        this.treeData = [response.data.children];
        this.$nextTick(() => {
          const root = this.$refs.chartTree.getNode(rootNode.treeKey);
          this.$refs.chartTree.setCurrentKey(root);
          root.expanded = true;
        });
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/chart/components/tree/LogicalTree.vue